// eslint-disable-next-line
import React from 'react'
import find from 'lodash/find'
import { connect } from 'react-redux'

import {
    addBillingAddress,
    selectBillingAddress,
    deleteAddress,
    updateAddress,
    UseShippingForBillingToggle
} from "./addressActionCreators"

import CheckoutAddressComponent from "./CheckoutAddressComponent"

const mapBillingAddressStateToProps = (state) => {
    const e = state.entities;
    const c = state.constants;
    const useShippingForBilling = state.ui.useShippingForBilling;

    let addresses = e.BillingAddresses.map(id => find(e.Addresses, address => address.Id === id));

    if (useShippingForBilling) {
        let shippingAddresses = e.ShippingAddresses.map(id => find(e.Addresses, address => address.Id === id));
        for (let i = 0; i < shippingAddresses.length; i++) {
            if (shippingAddresses[i].Id == e.SelectedShippingAddressId) {
                addresses.unshift(shippingAddresses[i]);
                break;
            }
        }
    }
    
    return {
        addresses: addresses,
        selectedAddressId: useShippingForBilling ? e.SelectedShippingAddressId : e.SelectedBillingAddressId,
        addressType: c.BillingAddressType,
        addressActionCreators: {
            add: addBillingAddress,
            remove: deleteAddress,
            select: selectBillingAddress,
            update: updateAddress
        },
        selectAddressMessage: "Bill to this address",
        useForAnotherMessage: "Same as shipping address",
        useForAnotherSelected: useShippingForBilling,
        sectionLabel: "Billing Address",
        readonly: useShippingForBilling
    }
};

const mapBillingAddressDispatchToProps = (dispatch) => ({
    onEndEdit: (Id) => dispatch(selectBillingAddress(Id)),
    onUseForAnotherClicked: () => dispatch(UseShippingForBillingToggle())
})
const CheckoutBillingAddressContainer = connect(
    mapBillingAddressStateToProps,
    mapBillingAddressDispatchToProps
)(CheckoutAddressComponent)

export default CheckoutBillingAddressContainer;